import PropTypes from "prop-types";
import { useHistory, useLocation, useRouteMatch } from "react-router";
import { useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import { useSelector, useDispatch } from "react-redux";
import { HeaderForLayout, HeaderForAdmin } from "@components/header";
import Navigator from "@components/navigator";
import Notification from "@components/notification";
import Loader from "@components/loader";
import PropertyPanel from "@components/property-panel";
import RightSideBar from "@routes/rightsidebar";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import clsx from "clsx";
import React, { useEffect, useMemo } from "react";
import ReactDOM from "react-dom";
import Loadable from "@react-loadable/revised";
import * as createAssetsBulkActions from "@modules/createAssetsBulk";
import { Grid, Toolbar } from "@mzc-pdc/ui";
import { Documents, Container, Main } from "@components_v2/layout/layout.styled";
import CustomNavigator from "@components/navigator/custom-navigator";
import useSettings from "@hooks/useSettings";
import InvalidURL from "@routes/errors/InvalidURL";
import { LayoutForNoting } from "@components/layout";

const LoadableCreateAssetsModal = Loadable({
    loader: () => import("@components/modals/CreateAssetsBulk"),
    loading: () => null,
});

const LayoutForComponentV2 = ({ routeType, children }) => {
    const location = useLocation();
    const dispatch = useDispatch();

    const globalLoading = useSelector((state) => state.global.loading);
    const isSidebarPushOpened = useSelector((state) => state.propertyPanel.isShow);
    const stageId = useSelector((state) => state.stage.id);
    const customMenus = useSelector(({ customMenus }) => customMenus);

    const isSidebarCoverOpened = useSelector((state) => state.rightSideBar.active);
    const isLineupPage = useMemo(
        () => location.pathname.indexOf("/schedules") > 0 && location.pathname.indexOf("/lineups") > 0,
        [location.pathname],
    );

    const createAssetsBulk = useSelector((state) => state.createAssetsBulk);

    const CreateAssetsBulkActions = bindActionCreators(createAssetsBulkActions, dispatch);

    return (
        <DndProvider backend={HTML5Backend}>
            <Documents
                className={clsx({
                    "property-panel panel-push-open": isSidebarPushOpened,
                    "panel-cover-open": isSidebarCoverOpened,
                    "in-fixed-tab": isLineupPage,
                })}
            >
                {location.pathname.indexOf("/admin/spaces") !== -1 ? (
                    <HeaderForAdmin location={location} />
                ) : (
                    <HeaderForLayout location={location} />
                )}
                {stageId && routeType === "custom" ? <CustomNavigator /> : <Navigator />}
                <Container>
                    <Toolbar />
                    <Main>{customMenus.error ? <InvalidURL /> : children}</Main>
                </Container>

                {stageId && (
                    <>
                        <PropertyPanel location={location} isLineupPage={isLineupPage} />
                        <RightSideBar location={location} isCustomMenu={routeType === "custom"} />
                    </>
                )}
                {globalLoading && <Loader />}
                <Notification />

                {createAssetsBulk.showModal &&
                    ReactDOM.createPortal(
                        <LoadableCreateAssetsModal
                            title={`Create Assets Bulk`}
                            onClose={() => {
                                CreateAssetsBulkActions.closeModal();
                            }}
                            initialSelectedFiles={createAssetsBulk.initialFiles}
                        />,
                        document.body,
                    )}
            </Documents>
        </DndProvider>
    );
};

LayoutForComponentV2.propTypes = {
    children: PropTypes.element,
};

export default LayoutForComponentV2;
